let airport = {
  name: 'AIRPORT',
};

let aircraft = {
  aircrafts: [],
  types: [],
  mappedTypes: {}
};

export default {
  ...airport,
  reset: function () {
    aircraft.aircrafts.splice(0);
    aircraft.types.splice(0);
    for (let key in aircraft.types) {
      delete aircraft.types[key];
    }
  },
  aircraft: {
    ...aircraft,
    setupType: function (type, area, durability, amount) {
      let aircraftType = {type, area, durability, amount, typeId: _.uniqueId()};
      aircraft.types.push(aircraftType);
      aircraft.mappedTypes[type] = aircraftType;
    },
    copyType: function (typeName) {
      let raw = typeName;
      let type = aircraft.types.find(type => type.type === typeName);
      let index = aircraft.types.findIndex(type => type.type === typeName);
      let rawMatcher = typeName.match(/-\d+$/);
      if (rawMatcher) {
        raw = typeName.substring(0, rawMatcher.index);
      }
      let regex = new RegExp(raw + '(-\\d+)?$');
      let maxSeries = aircraft.types.filter(type => regex.test(type.type)).length;
      aircraft.types.forEach(function (type) {
        let matcher = type.type.match(regex);
        if (matcher && matcher.length > 1 && matcher[1]) {
          let series = Number(matcher[1].substring(1));
          if (series > maxSeries) {
            maxSeries = series
          }
        }
      });
      type = {...type, type: raw + '-' + (maxSeries + 1), typeId: _.uniqueId()};
      aircraft.types.splice(index + 1, 0, type);
      aircraft.mappedTypes[type.type] = type;
      return type.type;
    },
    dropType: function (typeName) {
      aircraft.types.splice(aircraft.types.findIndex(type => type.type === typeName), 1)
    },
    buildInstance: function (type) {
      let typedInstance = aircraft.aircrafts.filter(instance => instance.type === type);
      let regex = new RegExp(type + '(-\\d+)?$');
      let maxSeries = typedInstance.length;
      typedInstance.forEach(function (instance) {
        let matcher = instance.name.match(regex);
        if (matcher && matcher.length > 1 && matcher[1]) {
          let series = Number(matcher[1].substring(1));
          if (series > maxSeries) {
            maxSeries = series
          }
        }
      });
      let name = type + '-' + String((maxSeries + 1) / 1000).substring(2);
      aircraft.aircrafts.push({name, ...aircraft.mappedTypes[type]});
      return name;
    },
    dropInstance: function (name) {
      if (name) {
        return aircraft.aircrafts.splice(aircraft.aircrafts.findIndex(type => type.name === name), 1)
      } else {
        return aircraft.aircrafts.splice(-1)
      }
    }
  }
}
